<template>
  <v-container class="pa-0">
    <div sticky-container>
      <SearchJourneyArticlesPanel @search="runSearch" v-sticky sticky-offset="{top: 48}"></SearchJourneyArticlesPanel>

      <JourneysByYearTabs></JourneysByYearTabs>
    </div>
  </v-container>
</template>

<script>
import SearchJourneyArticlesPanel from '@/components/SearchJourneyArticlesPanel.vue'
import JourneysByYearTabs from '@/components/JourneysByYearTabs.vue'
import Sticky from 'vue-sticky-directive'

export default {
  directives: { Sticky },
  components: {
    SearchJourneyArticlesPanel,
    JourneysByYearTabs
  },

  created() {},
  methods: {
    runSearch() {
      this.$router.push('/jarticles/')
    }
  }
}
</script>

<style></style>
